import { CITY_LANDING_PAGE_IDS } from '@/pages/city_landing/page_ids';

pageLoad(...CITY_LANDING_PAGE_IDS, () => {
  $('article.v4.soon_new_storages .submit').on('click', () => {
    alert('not implemented');
  });
});
